module.exports = __webpack_public_path__ + "static/media/3-3-redcube.a3185a25.png";